<footer>
  <div class="footer-wrap">
    <span class="footer-operator"><small>&copy;</small> CCC MK HOLDINGS Co.,Ltd.</span>
  </div>
</footer>
